import React, { useContext } from 'react';
import { isDesktop } from "react-device-detect";

//context
import GalleryContext from '../../context/GalleryContext';

//components
import Loading from '../common/Loading';
import BackgroundImage from '../common/BackgroundImage';
import Button from '../common/Button';
import EmptySpace from '../common/EmptySpace';

const Home = () => {

    const { dataGallery, loading } = useContext(GalleryContext);
    const { epigraph1, epigraph2, gallery, queryStringText, qryStrStart, title, title1, title2, urlAssets, urlEspecial, textButton } = dataGallery;

    const backgroundImage = isDesktop ? 'home-desktop' : 'home-mobile';

    const altImage = `${title} ${epigraph1} ${epigraph2}`;

    const firstPhoto = gallery ? (Object.keys(gallery)).shift() : '';

    return (
        loading
            ? <Loading /> 
            : <section className="position-relative text-center gallery-home cont-layout">
                <BackgroundImage alt={altImage} backgroundImage={backgroundImage} emptySpace={true} urlAssets={urlAssets}  />
                <section className="position-absolute start-50 translate-middle-x mx-auto w-100 text-center cont-layout container-titular">
                    <article className="">
                        <h1 className="mb-0 text-red">
                            <span className="title-1">{title1}</span><br/>
                            <span className="text-uppercase title-2">{title2}</span>
                        </h1>
                        <p className="mb-0">
                            <span className="text-white epigraph-1">{epigraph1}</span><br/>
                            <span className="text-uppercase text-red epigraph-2">{epigraph2}</span>
                        </p>
                        <Button 
                            classButton="bg-white btn-start"
                            text={textButton}
                            url={`${urlEspecial}${qryStrStart}${queryStringText}=${firstPhoto}`}
                        />
                    </article>                                                
                    <EmptySpace />
                </section>
            </section>
    )
}

export default Home;
